// extracted by mini-css-extract-plugin
module.exports = {"tertiaryBtnWithIcon":"tertiaryButtonWithIcon_tertiaryBtnWithIcon__4Qu7e"};